<template>
    <aside class="scrollbar-hidden pb-28 h-full bg-white overflow-x-hidden overflow-y-scroll lg:flex-shrink-0 lg:order-first">
        <div class="flex flex-col w-full">
            <nav aria-label="conversations" class="flex-1 bg-white">
                <ul class="border-b border-gray-200 divide-gray-200 divide-y" role="list">
                    <li v-for="conversation in conversations" class="relative bg-white">
                        <conversation :conversation.sync="conversation" />
                    </li>
                </ul>
            </nav>
        </div>
    </aside>
</template>

<script>
import Conversation from "@/Pages/Messenger/Conversation"

export default {
    components: { Conversation },

    props: {
        participant: {
            required: true,
            type: Object | null,
        },
        conversations: {
            required: true,
            type: Array,
        },
    },
}
</script>
